import React from 'react';
import GoogleTagManager from 'lib/GoogleTagManager';

import SashiDo from 'lib/SashiDo';

import Icon from 'components/Icon/Icon.react';
import Toggle from 'components/Toggle/Toggle.react';
import Modal from 'components/Modal/Modal.react';

import Notification from 'components/Notification/Notification.react';

import stylesSettings from 'dashboard/Settings/Settings.scss';
import styles from './Login.scss';

export default class AccountActivation extends React.Component {
  constructor() {
    super();
    this.state = {
      isActive: true,
      note: {
        type: '',
        message: '',
      },
      agree: false,
      showPolicies: false,
      showTos: false,
      user: null,
    };

    this.handleKey = this.handleKey.bind(this);
    this.handleSubmitButton = this.handleSubmitButton.bind(this);
  }

  async componentDidMount() {
    SashiDo.logOut();
    document.body.addEventListener('keydown', this.handleKey);

    try {
      const user = await SashiDo.getUserByActivation({ activation: this.props.params.activation });

      if (user) {
        this.setState({ user, isActive: false });
      } else {
        this.setState({
          isActive: true,
          notValidActivationCode: true,
        });
      }
    } catch (e) {
      console.log('ERROR', e);
    }


    setTimeout(() => {
      this.setFocus();
    }, 1000);
  }

  componentWillUnmount() {
    document.body.removeEventListener('keydown', this.handleKey);
  }

  onClose() {
    this.setState({
      agree: false,
      showPolicies: false,
      showTos: false,
    });
  }

  setFocus() {
    const password = this.passwordInput;
    const password2 = this.password2Input;
    password.focus();
    password.value = '';
    password2.value = '';
  }

  handleKey(e) {
    const keyCode = e.keyCode || e.which;
    switch (keyCode) {
      case 13:
        this.handleSubmitButton(this);
        break;
      default:
        break;
    }
  }

  handleSubmitButton() {
    setTimeout(() => {
      const username = this.state.user.username.toLowerCase();
      const password = this.passwordInput;
      const password2 = this.password2Input;

      const { activation, forgot } = this.props.params;

      if (password.value === password2.value && username === password.value.toLowerCase()) {
        this.setState({
          isActive: false,
          note: {
            type: 'error',
            message: 'Weak password.',
          },
        });

        return
      }


      if (password.value === password2.value) {
        this.setState({
          isActive: true,
          note: null,
        });

        SashiDo.activateUserAccount({
          username,
          password: password.value,
          password_confirm: password2.value,
          activation,
          forgot,
          agreeUsePersonalData: this.state.agree,
        }).then(({ error }) => {
          if (error) {
            this.setState({
              isActive: false,
              note: {
                type: 'error',
                message: error,
              },
            });

            password.value = '';
            password2.value = '';
            password.focus();

            return null;
          }

          SashiDo.logIn({ username, password: password.value }).then(() => {
            setTimeout(() => {
              GoogleTagManager({
                data: {
                  event: 'activated',
                  pageCategory: 'sign-up',
                },
              });

              window.location = '/products/apps';
            }, 2000);
          }).catch((error) => {
            this.setState({
              isActive: false,
              note: {
                type: 'error',
                message: error.message,
              },
            });
          });
        });
      }
      else {
        this.setState({
          isActive: false,
          note: {
            type: 'error',
            message: 'Your password confirmation is not correct.',
          },
        });

        password2.value = '';
        password2.focus();
      }
    }, 100);
  }

  render() {
    const classes = [
      styles.content,
    ];

    if (this.state.isActive && !this.state.notValidActivationCode) {
      classes.push(styles.loading);
    }

    const policiesView =
      this.state.showPolicies &&
      <Modal
        width={740}
        title="Privacy Notice"
        confirmText="I Accept"
        cancelText="Go Back"
        onCancel={() => this.onClose()}
        onConfirm={() => {
          this.setState({
            agree: true,
            showPolicies: false,
          });
        }}>
        <div>
          <iframe className={stylesSettings.Policies} width="100%" height="100%" src="https://www.sashido.io/en/policies/dashboard#gdpr-privacy-notice" title="SashiDo gdpr-privacy-notice" />
          <div className={stylesSettings.modalCustomInfo}>
            <p>You represent and warrant that:</p>

            <ol>
              <li>You have full legal authority to agree to these terms presented above.</li>
              <li>You have read and understand these terms.</li>
              <li>You agree to these terms.</li>
            </ol>

            <p>If you do not have the authority, or do not agree to these terms, do not click the "I Accept" button below.</p>
          </div>
        </div>
      </Modal>;

    const tosView =
      this.state.showTos &&
      <Modal
        width={740}
        title="Terms of Service"
        confirmText="I Accept"
        cancelText="Go Back"
        onCancel={() => this.onClose()}
        onConfirm={() => {
          this.setState({
            agree: true,
            showTos: false,
          });
        }}>
        <div>
          <iframe className={stylesSettings.Policies} width="100%" height="100%" src="https://www.sashido.io/en/policies/dashboard" title="SashiDo Policies" />
          <div className={stylesSettings.modalCustomInfo}>
            <p>You represent and warrant that:</p>

            <ol>
              <li>You have full legal authority to agree to these terms presented above.</li>
              <li>You have read and understand these terms.</li>
              <li>You agree to these terms.</li>
            </ol>

            <p>If you do not have the authority, or do not agree to these terms, do not click the "I Accept" button below.</p>
          </div>
        </div>
      </Modal>;

    return (
      <div className={styles.login}>
        <div className={styles.showEffect} />
        <div className={styles.wrapper}>
          <div className={styles.logo}>
            <img src="/assets/images/logo.svg" width="180" alt="SashiDo" />
          </div>
          <div className={classes.join(' ')}>
            {
              this.state.notValidActivationCode
                ?
                <div className={styles.form}>
                  <p className={styles.title}>The activation code is not valid.</p>

                  <p>Please contact us!</p>
                </div>
                :
                <form action="/login" data-loading-text="Log In" className={styles.form}>
                  <p className={styles.title}>Welcome on board!</p>
                  <p>{this.state.user ? this.state.user.username : ''}</p>

                  <p className={styles.subtitle}>Set your password</p>
                  <input
                    name="password"
                    placeholder="password"
                    className={styles.username}
                    type="password"
                    ref={(input) => {
                      if (input) {
                        input.focus();
                        this.passwordInput = input;
                      }
                    }} />
                  <Icon name="icon-lock" width={16} height={16} fill="#fff" />

                  <input
                    name="password2"
                    placeholder="confirm password"
                    className={styles.password}
                    type="password"
                    ref={(input) => {
                      if (input) {
                        this.password2Input = input;
                      }
                    }} />
                  <Icon name="icon-lock" width={16} height={16} fill="#fff" />


                  <div className={styles.agree}>
                    <Toggle
                      value={this.state.agree}
                      onChange={agree => this.setState({ agree })} />

                    <p>I agree that SashiDo uses my personal data for provision of services in accordance with SashiDo's<br /> <a href="javascript:;" onClick={() => this.setState({ showTos: true })}>Terms of Service</a> and <a href="javascript:;" onClick={() => this.setState({ showPolicies: true })}>Privacy Notice</a>.</p>
                  </div>

                  <a
                    id="submit"
                    href="javascript:;"
                    className={[styles.button, !this.state.agree ? styles.disable : ''].join(' ')}
                    onClick={this.handleSubmitButton.bind(this)}>
                    <i className={styles.spinner} /><span>Activate</span>
                  </a>
                </form>
            }
          </div>
        </div>
        <Notification note={this.state.note} fullscreen close />
        {policiesView}
        {tosView}
      </div>
    );
  }
}
